import React, { useState } from 'react';
import {
    Box,
    Button,
    Grid,
    Typography
} from '@mui/material';

import authService from '../Auth/AuthService';
import { useNavigate } from 'react-router-dom';

const CouponCard = ({ item, onApply }) => {
    const navigate = useNavigate();
    const isExpired =
        new Date(item.endDate + "T23:59:59") < new Date();
    const isApplied = item.isUsed ? true : false;
    const handleApply = () => {
        if (isExpired) return;

        // onApply({
        //     id: item.id,
        //     couponId: item.coupon.id,
        //     code: item.coupon.code,
        //     discountPercentage: item.coupon.discountPercentage,
        //     discountAmount: item.coupon.discountAmount,
        // });

        // navigate('/checkout', {
        //     state: { plan: {...item.coupon} }
        // });
    };

    return (
        <Box
            sx={{
                display: "flex",
                width: 350,
                height: 140,
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 4,
                background: isExpired ? "#e0e0e0" : "#fff",
                opacity: isExpired ? 0.6 : 1,
                filter: isExpired ? "grayscale(80%)" : "none",
                position: "relative",
            }}
        >
            {/* LEFT STRIP */}
            <Box
                sx={{
                    width: 70,
                    background: isExpired ? "#9e9e9e" : "#080b12",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    writingMode: "vertical-rl",
                    textOrientation: "mixed",
                    fontWeight: "bold",
                }}
            >
                {item?.coupon?.discountPercentage || 0}% OFF
            </Box>

            {/* CENTER */}
            <Box sx={{ flex: 1, p: 2, position: "relative" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    color={isExpired ? "gray" : "#080b12"}
                >
                    COUPON
                </Typography>

                <Typography variant="body2">
                    Code: {item?.coupon?.code}
                </Typography>

                <Typography variant="body2">
                    Valid: {item?.startDate} → {item?.endDate}
                </Typography>

                {/* perforation effect */}
                <Box
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: 10,
                        background:
                            "radial-gradient(circle at center, transparent 6px, #fff 6px)",
                        backgroundSize: "10px 20px",
                    }}
                />

                {/* APPLY BUTTON */}
                <Button
                    variant="contained"
                    size="small"
                    disabled={isExpired || isApplied}
                    onClick={handleApply}
                    sx={{
                        mt: 1,
                        background: isApplied
                            ? "green"
                            : isExpired
                                ? "gray"
                                : "#080b12",
                    }}
                >
                    {isApplied ? "Applied" : "Apply"}
                </Button>
            </Box>

            {/* RIGHT VALUE */}
            {/* <Box
                sx={{
                    width: 100,
                    background: isExpired ? "#9e9e9e" : "#8B0A2A",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 20,
                    fontWeight: "bold",
                }}
            >
                {item?.coupon?.discountAmount
                    ? `₹${item.coupon.discountAmount}`
                    : `${item?.coupon?.discountPercentage || 0}%`}
            </Box> */}

            {/* EXPIRED BADGE */}
            {isExpired && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        background: "red",
                        color: "#fff",
                        px: 1,
                        borderRadius: 1,
                        fontSize: 12,
                    }}
                >
                    EXPIRED
                </Box>
            )}
        </Box>
    );
};

const ReferralCoupon = ({ data }) => {
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const handleApplyCoupon = (coupon) => {
        // 👉 (API or cart update)
        console.log("Applied coupon:", coupon);
        setAppliedCoupon(coupon);
    };

    return (
        <Grid container spacing={2}>
            {data?.map((item) => (
                <Grid item key={item.id}>
                    <CouponCard
                        item={item}
                        onApply={handleApplyCoupon}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default ReferralCoupon;